import React, { useEffect, useState } from 'react'
import BlogDetailSection from '../../../components/BlogComponents/BlogDetailSection'
import Footer from '../../../components/MainComponents/Footer'
import Header from '../../../components/MainComponents/Header';
import ContactHeader from '../../../components/MainComponents/ContactHeader';
import AppointmentSection from '../../../components/ServiceComponents/AppointmentSection';
import { blogs, getBlogById } from '../../../utils/BlogData';
import { useParams } from 'react-router-dom';


  
  
  


const BlogDetail = () => {
  const { blogId } = useParams();
  const [blog, setblog] = useState({});

  useEffect(() => {
    const blogData = getBlogById(blogId);
    setblog(blogData);
  }, [blogId]);

  if (!blog) {
    return <div>Loading...</div>;
  }

  
  return (
    <div className='bg-background'>
        <ContactHeader/>
        <Header/>
        <BlogDetailSection blog={blog} relatedBlogs={blogs}/>
        <AppointmentSection/>
        <Footer/>
    </div>
  )
}

export default BlogDetail